module.exports = __webpack_public_path__ + "static/clutter-dots-pink-e6da9635477c4c4a5f0f68740767787b.png";